<script setup lang="ts">
import type { CampaignInclusionPeriodI } from "~/modules/campaign/components/CampaignOperationMgrFunnelStep3InclusionPeriods.vue";
import type { CampaignOperationParameter } from "~/modules/campaign/models/CampaignOperationParameter.interface";

const props = defineProps<{
  campaignOperationParameterWithInclusionPeriods?: CampaignOperationParameter;
}>();

const { t } = useI18n();

const inclusionPeriods = computed(() => {
  const inclusionPeriods: Map<string, string> = new Map([
    ["MONDAY", ""],
    ["TUESDAY", ""],
    ["WEDNESDAY", ""],
    ["THURSDAY", ""],
    ["FRIDAY", ""],
    ["SATURDAY", ""],
    ["SUNDAY", ""],
  ]);

  if (
    props.campaignOperationParameterWithInclusionPeriods &&
    props.campaignOperationParameterWithInclusionPeriods
      .customInputParameters &&
    (
      props.campaignOperationParameterWithInclusionPeriods.customInputParameters
        ?.inclusionPeriods as CampaignInclusionPeriodI[]
    ).length > 0
  ) {
    for (const inclusionPeriod of props
      .campaignOperationParameterWithInclusionPeriods.customInputParameters
      .inclusionPeriods as CampaignInclusionPeriodI[]) {
      const valueOfDay = inclusionPeriods.get(inclusionPeriod.day);
      const value = valueOfDay
        ? `${valueOfDay} | ${inclusionPeriod.start} - ${inclusionPeriod.end}`
        : `${inclusionPeriod.start} - ${inclusionPeriod.end}`;
      inclusionPeriods.set(inclusionPeriod.day, value);
    }
  } else {
    for (const key of inclusionPeriods.keys()) {
      inclusionPeriods.set(key, "00:00 - 00:00");
    }
  }
  return inclusionPeriods;
});
</script>

<template>
  <p class="underline underline-offset-auto font-medium">
    {{ t("campaign.details.characteristics.inclusionPeriods.title") }}
  </p>
  <div v-for="[key, value] in inclusionPeriods" :key="key">
    <p v-if="value.length" class="font-medium">
      {{
        t(
          `campaign.details.characteristics.inclusionPeriods.${key.toLocaleLowerCase()}`,
          { value: `${value}` },
        )
      }}
    </p>
    <p v-else class="text-gray-500 font-medium">
      {{
        t(
          `campaign.details.characteristics.inclusionPeriods.${key.toLocaleLowerCase()}`,
          {
            value: t(
              `campaign.details.characteristics.inclusionPeriods.inactive`,
            ),
          },
        )
      }}
    </p>
  </div>
</template>
